import { render, staticRenderFns } from "./AnswerPopup.vue?vue&type=template&id=1d8ceb84&scoped=true&"
import script from "./AnswerPopup.vue?vue&type=script&lang=ts&"
export * from "./AnswerPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerPopup.vue?vue&type=style&index=0&id=1d8ceb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ceb84",
  null
  
)

export default component.exports